import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { CTAButton } from './CTAButton';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function HeroSection() {
  const painBullets = ['Si el No-Show te cuesta miles en tiempo y recursos cada mes', 'Si dependes de referencias médicas para conseguir pacientes nuevos', 'Si tus pacientes no regresan para los tratamientos de seguimiento', 'Si no apareces en Google cuando buscan tu especialidad en tu ciudad', 'Si estás perdiendo pacientes con tu competencia que tiene mejor presencia digital aunque no sea mejor clínica'];
  return <section className="min-h-screen flex items-center pt-20 pb-16 px-4 md:px-8 max-w-5xl mx-auto" data-id="element-36">
      <motion.div variants={containerVariants} initial="hidden" animate="visible" className="w-full" data-id="element-37">
        <motion.div variants={itemVariants} className="mb-4" data-id="element-38">
          <span className="text-gold font-bold tracking-wider text-sm md:text-base uppercase" data-id="element-39">
            Doctor Ecommerce
          </span>
        </motion.div>

        <motion.h1 variants={itemVariants} className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-8 text-white" data-id="element-40">
          ¿Tu clínica tiene citas canceladas,
          <br className="hidden md:block" data-id="element-41" />
          <span className="text-gray-400" data-id="element-42">sillas vacías y pacientes</span>
          <br className="hidden md:block" data-id="element-43" />
          <span className="text-gold" data-id="element-44">que no regresan?</span>
        </motion.h1>

        <motion.p variants={itemVariants} className="text-lg md:text-xl text-gray-300 mb-12 max-w-3xl leading-relaxed" data-id="element-45">
          Implementamos el{' '}
          <strong className="text-white font-bold" data-id="element-46">
            Sistema A.C.E.™ Clínico
          </strong>
          : el protocolo de adquisición de pacientes que llena tu agenda con
          personas que necesitan tus servicios específicos, tienen seguro o
          capacidad de pago y se convierten en pacientes recurrentes.
        </motion.p>

        <motion.div variants={itemVariants} className="mb-12 space-y-4 max-w-2xl" data-id="element-47">
          {painBullets.map((bullet, index) => <motion.div key={index} variants={itemVariants} className="flex items-start bg-white/5 p-4 rounded-lg border border-white/10" data-id="element-48">
              <AlertTriangle className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-49" />
              <span className="text-gray-200 text-base md:text-lg leading-snug" data-id="element-50">
                {bullet}
              </span>
            </motion.div>)}
        </motion.div>

        <motion.div variants={itemVariants} data-id="element-51">
          <CTAButton text="QUIERO MÁS PACIENTES CALIFICADOS" data-id="element-52" />
        </motion.div>
      </motion.div>
    </section>;
}